import { createSelector } from 'reselect';

import {
  getTaxonomyPathFromItem,
  getTaxonomyPaths,
  hasDiscoverTaxonomy,
  isGenericGb,
  keepsNativePsychographicTree,
  replacePsycoWithLifestyle,
} from '@discover-frontend/utils';
import { alphabeticallySortByKey } from 'src/utils';
import { getLevelWithFusionPsychographic } from '../operations/taxonomy';
import {
  hasGwiFusion,
  hasWWGwiMediaFusion,
  hasMriSimmonsFusion,
  hasTgiFusion,
} from '../utils/AuthHelperMethods';

export { getTaxonomyPathFromItem, getTaxonomyPaths };

const selectTaxonomy = (state) => state.taxonomyList;
const selectDataSource = (state) => state.queryBuilder.dataSource;

const getFilteredTaxonomy = ({ list }) => {
  return list.map((level, index) => {
    const levelWithDescription = level.map((item) => ({
      ...item,
      description: item.lineage,
    }));
    if (index > 0) {
      const changed = getLevelWithFusionPsychographic(
        levelWithDescription,
        index,
        hasMriSimmonsFusion(),
        hasGwiFusion(),
        hasWWGwiMediaFusion(),
        hasTgiFusion(),
        hasDiscoverTaxonomy(),
        isGenericGb()
      );
      return changed.sort(alphabeticallySortByKey('label'));
    }

    const firstLevelOrder = [
      'demographic',
      'lifestyle',
      'psychographic',
      '-2',
      '-1',
      '-3',
      '-4',
      '-5',
      '-7',
      '-6',
      '-8',
    ];

    const firstLevel =
      index > 0
        ? levelWithDescription.sort(alphabeticallySortByKey('label'))
        : levelWithDescription.sort(
            (a, b) =>
              firstLevelOrder.indexOf(a.id) - firstLevelOrder.indexOf(b.id)
          );

    const firstLevelWithLifestyle = keepsNativePsychographicTree()
      ? firstLevel
      : replacePsycoWithLifestyle(firstLevel, {
          label: hasWWGwiMediaFusion() ? 'Psychographics' : 'Lifestyles',
          description: hasWWGwiMediaFusion() ? 'Psychographics' : 'Lifestyles',
          psychographicType: 'psychographic',
        });

    return [
      ...firstLevelWithLifestyle,
      {
        id: 'saved-queries',
        label: 'Saved queries',
        description: 'Saved queries',
      },
    ];
  });
};

export const getExplorerTaxonomy = createSelector(
  [selectTaxonomy, selectDataSource],
  (taxonomy, dataSource) => {
    return {
      ...taxonomy,
      baseTaxonomy: taxonomy.baseTaxonomy[dataSource],
      baseTaxonomyWithLifestyles:
        taxonomy.baseTaxonomyWithLifestyles[dataSource],
      data: getFilteredTaxonomy({
        list: (taxonomy.data[dataSource] && taxonomy.data[dataSource]) || [],
      }),
    };
  }
);
